import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/main.scss';
import App from './App';
import {BrowserRouter} from 'react-router-dom';

const host = window.location.host;
const http = window.location.protocol;
let a = host;
if(host.includes('localhost'))  a = '127.0.0.1:8000';
if(host.includes('devel'))  a = 'pvvr.tw-planner.com';
//if(host.includes('nehodananecisto'))  a = window.location.host+"/index.php";
if(host.includes('nehodananecisto'))  a = window.location.host;
export const APIURL = http+"//"+a+"/api";


const root = ReactDOM.createRoot(document.body);
root.render(
  <React.StrictMode>
    {/** //K nasazení
     * <BrowserRouter basename='/public'>
      <App />
    </BrowserRouter>
     */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
